import * as actionTypes from './authenticationActionTypes';

export const login = (username,userId) => ({type: actionTypes.LOGIN, username:username,userId:userId});
export const logout = () => ({type: actionTypes.LOGOUT});
